import { render, staticRenderFns } from "./checkTranBoxLabels.vue?vue&type=template&id=62a90940&scoped=true&"
import script from "./checkTranBoxLabels.vue?vue&type=script&lang=js&"
export * from "./checkTranBoxLabels.vue?vue&type=script&lang=js&"
import style0 from "./checkTranBoxLabels.vue?vue&type=style&index=0&id=62a90940&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a90940",
  null
  
)

component.options.__file = "checkTranBoxLabels.vue"
export default component.exports